import LightLayout from '../../../../../shared/Layouts/LightLayout'
import taskSandboxCss from '../taskSandbox.module.css'
import css from './zeroTaskSandbox.module.css'
import sandboxCss from '../taskSandbox.module.css'
import CreateTextOptionModal from '../../CreateTextOptionModal'
import PngDropzone from '../../../../../shared/Dropzone/PngDropzone'
import TextOption from '../../TextOption'
import { IImage, ITask } from '../../../../../types/tasks.types'
import useSandboxTask from '../useSandboxTask'
import TextInput from '../../../../../shared/Inputs/TextInput'
import useDraftScale from '../useDraftScale'

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const ZeroTaskSandbox = (props: IProps) => {
  const ctrl = useSandboxTask(props.onDraftTaskChange)
  const scaleCtrl = useDraftScale(ctrl.draftTask, ctrl.handleImageScaleChange)

  const renderOptions = () => {
    return ctrl.draftTask.answerOptions.map((option, index) => (
      <TextOption
        option={option}
        index={index}
        key={index}
        onDelete={ctrl.handleOptionDelete}
        onChange={ctrl.handleOptionChange}
      />
    ))
  }

  return (
    <div className={taskSandboxCss.wrapper}>
      {ctrl.createOptionModalOpen && (
        <CreateTextOptionModal onClose={ctrl.toggleCreateOptionModal} onCreate={ctrl.handleOptionCreate} />
      )}
      <LightLayout>
        <div className={css.wrapper}>
          <div className={css.imageUpload}>
            <TextInput
              inscription="Ширина картинки, %"
              value={scaleCtrl.imageScale}
              name="scale"
              onChange={scaleCtrl.handleChange}
            />
            <PngDropzone onFile={ctrl.handleImage} image={ctrl.draftTask.images[0] as IImage} key={ctrl.draftTask.id} />
          </div>
          <div className={css.options}>
            {renderOptions()}
            <div className={sandboxCss.addOption} onClick={ctrl.toggleCreateOptionModal}>
              Добавить карточку
            </div>
          </div>
        </div>
      </LightLayout>
    </div>
  )
}

export default ZeroTaskSandbox
